import { PipeTransform, Pipe } from "@angular/core";

@Pipe({
    name: 'workFilter'
})
export class workPipe implements PipeTransform {
    transform(works, workid) {
        if (works && works.length) {
            return works.filter(work => {
                return this.workHandler(work, workid);
            })
        }
    }
    workHandler(work, workid) {
        if (work.id === workid) {
            return true;
        }
    }
}